import { Note } from 'one-card-notes-history';
import { format } from 'one-util-date';
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Pending Referal component
 * @param response is the raw json data returned from API.
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    let notes: Note[] = [];
    let result: any = {
        notes: [],
        error: undefined
    }
    if (response && (response.status >= 400 || response.type == "error")) {
        result.error = response;
    }
    else if (response) {
        // Handle both direct array and wrapped response
        let responseArray = Array.isArray(response) ? response : (response.results || response.data || []);
        if (Array.isArray(responseArray) && responseArray.length > 0) {
            responseArray.forEach((ele: any) => {
                let info: Note = {
                    note: ele.notes ?? '',
                    agentId: ele.agent_id ?? '',
                    date: format(ele.datetime, 'MM-DD-YYYY'),
                    time: format(new Date(ele.datetime), 'hh:mm:ss A'),
                    isEpic: ele.is_epic === 't' ? true : false
                            };
                notes.push(info);
            });
            result.notes = notes;
        }
    }

    return result;
}
